module.exports = __webpack_public_path__ + "static/media/amex.af49d3cd.svg";